<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  @if (data.submitNewRequestDialog.isSubmitNewRequest) {
    <h6 mat-dialog-title>
      {{data.sysText.submitNewRequest_title | titlecase}}
    </h6>
  }
  @if (!data.submitNewRequestDialog.isSubmitNewRequest) {
    <h6 mat-dialog-title>
      {{data.sysText.submitNewRequest_addCaseTitle | titlecase}}
    </h6>
  }
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <div class="main-container">
    @if (!isForSelf) {
      <app-autocomplete-field
        [group]="form"
        [control]="form.controls.employeeId"
        [icon]="'person'"
        [label]="data.sysText.submitNewRequest_employee"
        [options]="data.submitNewRequestDialog.employeeOptions"
        [interfaceName]="'employee'"
        [isDisabled]="isNewEmployee"
        (hintClick)="onEEHintClick()"
        [hasClickableHint]="true"
        [showSearchIcon]="true"
        [showImage]="true"
        [comboMsError]="true">
      </app-autocomplete-field>
    }
    @if (isNewEmployee && !isForSelf) {
      <div class="new-employee">
        <div class="sub-employee">
          <div class="new-ee-column">
            <app-input-field
              [label]="data.sysText.submitNewRequest_firstName"
              [control]="newEmployee.controls.firstName"
              [group]="form">
            </app-input-field>
          </div>
          <div class="new-ee-column left-margin">
            <app-input-field
              [label]="data.sysText.submitNewRequest_middleName"
              [control]="newEmployee.controls.middleName"
              [group]="form"
              [hideIconSpace]="!(isMobile$ | async)">
            </app-input-field>
          </div>
        </div>
        <div class="sub-employee">
          <div class="new-ee-column">
            <app-input-field
              [label]="data.sysText.submitNewRequest_lastName"
              [control]="newEmployee.controls.lastName"
              [group]="form">
            </app-input-field>
          </div>
          <div class="new-ee-column left-margin">
            <app-input-field
              [label]="data.sysText.submitNewRequest_suffix"
              [control]="newEmployee.controls.suffix"
              [group]="form"
              [hideIconSpace]="!(isMobile$ | async)">
            </app-input-field>
          </div>
        </div>
        <div class="new-ee-full-column">
          <app-input-field
            [label]="data.sysText.submitNewRequest_preferredName"
            [control]="newEmployee.controls.preferredName"
            [group]="form">
          </app-input-field>
        </div>
        <div class="new-ee-full-column">
          @if (data.submitNewRequestDialog.companyOptions?.length > 0) {
            <app-select-field
              [group]="form"
              [control]="form.controls.companyId"
              [options]="data.submitNewRequestDialog.companyOptions"
              [label]="data.sysText.submitNewRequest_company"
              [shouldCapitalize]="false">
            </app-select-field>
          }
        </div>
      </div>
    }
    <app-email-field-group
      [group]="form"
      [workEmailControl]="workEmail"
      [isWorkEmailPreferredControl]="isWorkEmailPreferred"
      [personalEmailControl]="personalEmail"
      [isPersonalEmailPreferredControl]="isPersonalEmailPreferred"
      [autocomplete]="isForSelf ? 'email' : 'off'">
    </app-email-field-group>
    <div class="sameRow-fields">
      <div class="sameRow-fields-left">
        <app-input-field
          [group]="form"
          [control]="form.controls.workPhoneNumber"
          [icon]="'phone'"
          [label]="data.sysText.submitNewRequest_workPhoneNumber"
          [inputType]="'string'"
          [autocomplete]="isForSelf ? 'work tel' : 'off'">
        </app-input-field>
      </div>
      <div class="sameRow-fields-right">
        <app-input-field
          [hideIconSpace]="!(isMobile$ | async)"
          [group]="form"
          [control]="form.controls.personalPhoneNumber"
          [label]="data.sysText.submitNewRequest_personalPhoneNumber"
          [inputType]="'string'"
          [autocomplete]="isForSelf ? 'home tel' : 'off'">
        </app-input-field>
      </div>
    </div>
    <div class="sameRow-fields">
      <div class="sameRow-fields-left">
        <app-date-field
          [label]="data.sysText.submitNewRequest_startDate"
          [control]="form.controls.startDate"
          [group]="form"
          [icon]="'date_range'"
          (emitDateChange)="updateEndDate()">
        </app-date-field>
      </div>
      <div class="sameRow-fields-right">
        <app-date-field
          [hideIconSpace]="!(isMobile$ | async)"
          [label]="data.sysText.submitNewRequest_endDate"
          [control]="form.controls.endDate"
          [group]="form">
        </app-date-field>
      </div>
    </div>
    <app-select-field
      [group]="form"
      [control]="form.controls.leaveReasonId"
      [options]="leaveReasonOptions"
      [showSpinner]="(leaveReasonsLoading$ | async)"
      [icon]="'live_help'"
      [label]="data.sysText.submitNewRequest_leaveReason"
      [hint]="leaveReasonHint"
      [isHintHighlighted]="false"
      [shouldCapitalize]="false">
    </app-select-field>
    <app-text-area
      [group]="form"
      [control]="form.controls.comments"
      [icon]="'comment'"
      [label]="data.sysText.submitNewRequest_comments">
    </app-text-area>

    <div class="section-header-container">
      <h2 class="overline grey1 semibold section-title">{{data.sysText.submitNewRequest_documents | uppercase}}</h2>
      <mat-divider class="section-header-underline"></mat-divider>
    </div>
    <input hidden type="file" #imgFileInput (change)="handleFileInput($event.target.files)" autocomplete="off"/>
    <div class="file-input-field">
      <mat-icon class="input-icon">attach_file</mat-icon>
      <button
        #uploadButton
        mat-stroked-button
        color="accent"
        class="button"
        (click)="imgFileInput.click()">
        <mat-icon>upload</mat-icon>
        <span>{{data.sysText.submitNewRequest_upload | capitalizefirst}}</span>
      </button>
    </div>
    @if (fileToUpload) {
      <div class="pad">
        <div class="flex-horiz bot-space">
          <mat-icon class="fill4-dk">check</mat-icon>
          <div>
            <span class="body2 side-space grey3">{{ fileToUpload?.name }}</span>
          </div>
          <button type="button" class="button-reset" [attr.aria-label]="data.sysText.removeFile_ariaLabel" (click)="clearFile()">
            <mat-icon class="black-inactive small pointer">clear</mat-icon>
          </button>
        </div>
      </div>
    }
    <app-input-field
      [group]="form"
      [control]="form.controls.documentTitle"
      [icon]="'description'"
      [label]="data.sysText.submitNewRequest_documentTitle">
    </app-input-field>
    <app-select-field
      [group]="form"
      [control]="form.controls.documentCategory"
      [options]="data.submitNewRequestDialog.documentCategoryOptions"
      [icon]="'list'"
      [label]="data.sysText.submitNewRequest_documentCategory"
      [shouldCapitalize]="false"
      [showBlankOption]="true">
    </app-select-field>
    <app-text-area
      [group]="form"
      [control]="form.controls.documentComments"
      [label]="data.sysText.submitNewRequest_docComments"
      [icon]="'comment'">
    </app-text-area>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (showNotificationToggle) {
    <div class="slide-container">
      <app-slide-toggle
        [control]="form.controls.sendNotification"
        [isDisabled]="(isSubmitting$ | async)"
        [label]="data.sysText.submitNewRequest_sendNotification">
      </app-slide-toggle>
    </div>
  }

  @let isSubmitting = isSubmitting$ | async;
  <div>
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        color="accent"
        [disabled]="isSubmitting"
        (click)="close(false)">
        {{data.sysText.cancel}}
      </button>
    }
    <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks -->
    <button
      mat-stroked-button
      class="button"
      color="accent"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
      (click)="!isSubmitting && onSubmit(false)">
      {{data.sysText.submit}}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </div>
</mat-dialog-actions>